// SliderSection.js
import React from "react";
import Grid from "@mui/material/Grid";
import Slider from "react-slick";
import SliderItem from "./SliderItem";
import CenterGrid from "../CenterGrid";
import { slider_settings } from "../LandingPage/functions_LandingPage.js";
import {makeStyles} from '@mui/styles';
import ReactGA from 'react-ga';
import { BigP } from "../styledComponents.js";



const useStyles = makeStyles((theme) => ({
    appStore: {
        display: "block",
        margin: "0 auto",
        [theme.breakpoints.down('md')]: {
            width: "80%",
        },
    },
}));



const onGotoAppStore = (e) => {
    ReactGA.event({
        category: "User",
        action: 'Clicked through to appstore',
        label: "https://apps.apple.com/gb/app/jigpaws/id1541336283"
    })
};

const SliderShipping = ({ includeCustomAppleSection }) => {



    const classes = useStyles();


    const shippingCards = [
    {
      img: "/images/svg/jpFreeShipping.svg",
      title: "Free UK Shipping!",
      body: <>International and next day<br />delivery also available</>,
      maxWidth: "140px"
    },
    {
      img: "/images/svg/intShipping.svg",
      title: "FREE INTERNATIONAL SHIPPING",
      body: "on jigsaws",
      maxHeight: "100px"
    }
  ];

    // if (includeCustomAppleSection) {
        return (
            <Grid item xs={12} md={6} className="bgGreen">
<Slider className="slickText" {...slider_settings} autoplaySpeed={10000} speed={500}>
      {shippingCards.map((card, index) => (
    <div key={index}>
      <CenterGrid>
        <Grid>
          <div className="spacer desktopNone" />
          <img
            className={classes.appStore}
            src={card.img}
            alt={card.title}
            style={{
              maxWidth: card.maxWidth,
              maxHeight: card.maxHeight
            }}
          />
          <div className="spacerSmall" />
          <div><h3>{card.title}</h3></div>
          <div className="spacerSmall" />
          <BigP className="body">{card.body}</BigP>
          <div className="spacer desktopNone" />
        </Grid>
      </CenterGrid>
    </div>
  ))}
</Slider>

            </Grid>
        );
};

export default SliderShipping;
